import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/firestore';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import { INVITATION_ACTIONS } from './invitations';
import { formatNumber } from './phone-numbers';

const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_FUNCTIONS_URL,
} = process.env;

const config = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

firebase.initializeApp(config);
firebase.firestore();

export function issueToken() {
  return firebase.functions().httpsCallable('users-issueToken')()
    .then(({ data: { token } }) => token);
}

export function getInvitationInformation(type, token) {
  return firebase.functions().httpsCallable('invitations-information')({ type, token });
}

export function answerInvitation(type, token, userData, action = INVITATION_ACTIONS.accept) {
  return firebase.functions().httpsCallable('invitations-answer')({
    type,
    token,
    action,
    userData,
  });
}

export function signInWithPhoneNumber(phoneNumber, recaptchaVerifier) {
  return firebase.auth().signInWithPhoneNumber(phoneNumber, recaptchaVerifier);
}

export function signOut() {
  return firebase.auth().signOut();
}

export function onAuthStateChanged(cb) {
  return firebase.auth().onAuthStateChanged(cb);
}

export function fetchProfile(uid) {
  return firebase.firestore().collection('users').doc(uid).get();
}

export function getCountryCode() {
  return fetch(`${REACT_APP_FIREBASE_FUNCTIONS_URL}/countryCode`)
    .then(res => res.json())
    .then(json => json.countryCode);
}

/**
 * When users are just created in Firebase, a CF is ran to create a record in Firestore.
 * There is a race condition between this function and that CF.
*/
export async function safeProfileFill(uid, dataToAdd) {
  const profileDoc = firebase.firestore().collection('users').doc(uid);
  const userProfileSnap = await profileDoc.get();

  if (userProfileSnap.exists) {
    const userProfileData = userProfileSnap.data();
    return profileDoc.set({
      phoneNumber: userProfileData.phoneNumber || formatNumber(dataToAdd.phoneNumber),
      firstName: userProfileData.firstName || dataToAdd.firstName,
      lastName: userProfileData.lastName || dataToAdd.lastName,
      birthday: userProfileData.birthday || dataToAdd.birthday,
    }, { merge: true });
  }

  return profileDoc.set(
    pickBy(pick(dataToAdd, ['phoneNumber', 'firstName', 'lastName', 'birthday']), identity),
    { merge: true },
  );
}

export default firebase;
